var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompactArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 14,
    viewBox: "0 0 33 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21458 7.42875C4.89091 7.23454 4.89091 6.76545 5.21458 6.57125L8.74275 4.45435C9.07601 4.25439 9.5 4.49445 9.5 4.8831L9.5 9.1169C9.5 9.50555 9.07601 9.74561 8.74275 9.54565L5.21458 7.42875Z",
    fill: "#47D061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7H23.5",
    stroke: "#47D061"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7854 6.57125C28.1091 6.76545 28.1091 7.23454 27.7854 7.42875L24.2572 9.54565C23.924 9.74561 23.5 9.50555 23.5 9.1169V4.8831C23.5 4.49445 23.924 4.25439 24.2572 4.45435L27.7854 6.57125Z",
    fill: "#47D061"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1H28.5V-1H4.5V1ZM31.5 4V10H33.5V4H31.5ZM28.5 13H4.5V15H28.5V13ZM1.5 10V4H-0.5V10H1.5ZM4.5 13C2.84315 13 1.5 11.6569 1.5 10H-0.5C-0.5 12.7614 1.73858 15 4.5 15V13ZM31.5 10C31.5 11.6569 30.1569 13 28.5 13V15C31.2614 15 33.5 12.7614 33.5 10H31.5ZM28.5 1C30.1569 1 31.5 2.34315 31.5 4H33.5C33.5 1.23858 31.2614 -1 28.5 -1V1ZM4.5 -1C1.73858 -1 -0.5 1.23858 -0.5 4H1.5C1.5 2.34315 2.84315 1 4.5 1V-1Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactArrow);
export default __webpack_public_path__ + "static/media/compactArrow.0ba0fed72bd733cf446b7c05cb820577.svg";
export { ForwardRef as ReactComponent };